var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9172 9.60446C21.108 8.02985 22.6217 5.65727 22.6217 3.77029C22.6217 1.68801 20.7802 0 18.5087 0C16.2371 0 14.3956 1.68801 14.3956 3.77029C14.3956 5.65727 15.9093 8.02985 17.1002 9.60446C18.5087 11.013 18.5087 11.013 19.9172 9.60446ZM18.5087 5.1413C19.0766 5.1413 19.5369 4.68093 19.5369 4.11304C19.5369 3.54515 19.0766 3.08478 18.5087 3.08478C17.9408 3.08478 17.4804 3.54515 17.4804 4.11304C17.4804 4.68093 17.9408 5.1413 18.5087 5.1413ZM14.6086 8.01311C15.0101 8.41468 14.7972 8.59844 14.3956 9L10.2826 13.113C9.88106 13.5146 9.44292 13.9819 9.04137 13.5803C8.63982 13.1788 8.98539 12.8733 9.38695 12.4717L13.5 8.35869C13.9015 7.95714 14.2071 7.61156 14.6086 8.01311ZM8.22608 16.1094C8.22608 17.9964 6.71242 20.369 5.5216 21.9436C4.11304 23.3521 4.11304 23.3521 2.70448 21.9436C1.51366 20.369 0 17.9964 0 16.1094C0 14.0271 1.84147 12.3391 4.11304 12.3391C6.38461 12.3391 8.22608 14.0271 8.22608 16.1094ZM5.1413 16.4522C5.1413 17.0201 4.68093 17.4804 4.11304 17.4804C3.54515 17.4804 3.08478 17.0201 3.08478 16.4522C3.08478 15.8842 3.54515 15.4239 4.11304 15.4239C4.68093 15.4239 5.1413 15.8842 5.1413 16.4522Z",
    fill: "#FF4545",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadRunning);
export default __webpack_public_path__ + "static/media/DeadRunning.784e08e5.svg";
export { ForwardRef as ReactComponent };